import { render, staticRenderFns } from "./PersonSearchPage.vue?vue&type=template&id=66a7b5a0&"
import script from "./PersonSearchPage.vue?vue&type=script&lang=js&"
export * from "./PersonSearchPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonSearchPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports